import React, { useContext } from 'react';
import { GoogleLogout } from 'react-google-login';
import { Link } from "react-router-dom";

import { FaSignOutAlt, FaBars } from 'react-icons/fa';

import LoginContext from '../../context/Login/LoginContext';

const clientId = process.env.REACT_APP_CLIENT_ID_AUTH_GMAIL   

const TopBar = ({toggled, isCollapsed}) => {
    const loginContext = useContext(LoginContext);
    const { logout, errorEvent } = loginContext;


    const btnToggled = () => {
        isCollapsed(!toggled)       
    }

    return ( 
        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                    
                    <button className="btn btn-link d-md-none rounded-circle mr-3" onClick={() => btnToggled()}>
                        <i className="fa fa-bars"><FaBars className="svg-icon"/></i>
                    </button>    
                    
                    <ul className="navbar-nav ml-auto">

                                          
                    <div className="topbar-divider d-none d-sm-block"></div>

                  
                        <li className="nav-item dropdown no-arrow">
                            <GoogleLogout 
                                clientId={clientId}
                                render= {renderProps => ( 
                                    <Link className="nav-link dropdown-toggle"  
                                        to={"/"} 
                                        onClick={renderProps.onClick} 
                                        disabled={renderProps.disabled}
                                    >
                                        <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"><FaSignOutAlt /></i>
                                        <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                            Logout
                                        </span> 
                                    </Link>
                                  
                                )}
                                buttonText="Logout"                                                    
                                onLogoutSuccess={logout}
                                onFailure={errorEvent}
                            />                            
                           
                        </li>

                    </ul>

                </nav>
     );
}
 


export default TopBar;
